// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3LMiS","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__nLAF_"};